import { motion } from "framer-motion";
import "../styles/pages/AboutUs.css";

const team = [
  {
    name: "Marta Latoch",
    photo: "/images/Marta.jpg", 
    bio: `Cześć, jestem programistką z artystyczną duszą, która zamiast stałego biura wybrała laptop, plecak i bilet w jedną stronę. Od kilku lat pracuję zdalnie i dużo podróżuję – i to właśnie z tych wyjazdów wzięła się moja supermoc: ogarnianie planów, logistyki i kryzysów na spokojnie, tak że nawet jeśli coś pójdzie nie tak, Ty najprawdopodobniej w ogóle tego nie zauważysz.

Na co dzień ogarniam techniczną stronę someet: tworzę i rozwijam naszą stronę internetową oraz pilnuję, żeby to, co dzieje się na żywo, miało swoje przedłużenie online.

Jestem ekstrawertyczką, która od zawsze najlepiej czuje się wśród ludzi. Kiedyś marzyłam o własnym biurze podróży, dziś zamiast sprzedawać wakacje, tworzę spotkania, na których można poznawać nowych ludzi, łapać inspiracje i czuć się jak w paczce znajomych.
Łączę więc to, co kocham najbardziej: ludzi, podróże, kreatywność i odrobinę chaosu, który zamieniam w dobrze zaplanowane wydarzenia. 

Na eventach zwykle zobaczysz mnie z kieliszkiem prosecco w jednej ręce i uśmiechem w drugiej. A jeśli akurat mnie nie ma, to pewnie tworzę nasze social media gdzieś w tropikach albo walczę na trasie maratonu.`
  },
  {
    name: "Marta Barcińska",
    photo: "/images/Marta1.jpg", 
    bio: `Cześć, jestem Marta. Od zawsze najlepiej czuję się tam, gdzie coś się dzieje — wśród ludzi, rozmów i dobrej energii. Kocham kreatywne projekty, estetyczne detale i budowanie atmosfery, w której każdy czuje się swobodnie.

Moja przygoda z eventami zaczęła się zupełnie naturalnie. Najpierw organizowałam spotkania dla znajomych, dbając o klimat, dekoracje i to, żeby każdy czuł się zaopiekowany. Z czasem dotarło do mnie, że to coś więcej niż hobby — to moja naturalna przestrzeń.

Jestem otwarta, kontaktowa i mam w sobie coś, co podobno przyciąga ludzi. Uwielbiam łączyć osoby z różnych światów i tworzyć przestrzeń, w której mogą się spotkać, poznać i po prostu dobrze bawić.

Inspirują mnie podróże, nowe doświadczenia i lekki, włoski klimat — to z nich czerpię pomysły na eventy pełne estetyki, swobody i dobrej energii.

Tak narodziło się soMeet — projekt, w którym mogę połączyć pasję do organizowania wydarzeń z naturalną potrzebą bycia wśród ludzi i tworzenia relacji.`
}
];

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: 0.15 * i } }),
};

const AboutUs = () => (
  <section className="about-me bg-gradient">

    {/* duże „tło” blobowe za całą sekcją */}
    <span className="section-blob section-blob-a" aria-hidden="true" />
    <span className="section-blob section-blob-b" aria-hidden="true" />

    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="container"
    >
      <h1 className="headline">Poznaj nas</h1>

      {/* dwie karty z osobami*/}
      <div className="team-grid">
        {team.map((p, i) => (
          <div className={`person-wrap ${i % 2 ? "wrap-right" : "wrap-left"}`} key={`${p.name}-${i}`}>
            {/* drobne ozdoby */}
            <span className={`blob blob-${i % 2 ? "b" : "a"}`} aria-hidden="true" />
            <span className={`dot dot-${i % 2 ? "r1" : "l1"}`} aria-hidden="true" />
            <span className={`dot dot-${i % 2 ? "r2" : "l2"}`} aria-hidden="true" />

            <motion.article
              className="person-card"
              variants={cardVariants}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.2 }}
              custom={i}
              whileHover={{ y: -4 }}
              transition={{ type: "spring", stiffness: 120, damping: 14 }}
            >
              <div className="person-media">
                <img src={p.photo} alt={`Zdjęcie ${p.name}`} className="person-photo" />
                <span className="photo-blob" aria-hidden="true" />
              </div>
              <div className="person-info">
                <h2 className="person-name">{p.name}</h2>
                {p.role && <div className="person-role">{p.role}</div>}
                <p className="person-bio">{p.bio}</p>
              </div>
            </motion.article>
          </div>
        ))}
      </div>
    </motion.div>
  </section>
);

export default AboutUs;